import React, { useEffect, useState } from 'react';
import { Avatar, Tooltip } from "@fluentui/react-components";
import { Building, Check, Mail, Phone, Send, User } from 'lucide-react';
import Input from "../../components/controls/input/customInput/CustomInput";
import apiService from "../../store/services/general.service";
import './HoverCard.scss';
import { generalActions } from '../../store/actions';
import { useDispatch } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { formatPhoneForTelHref, formatPhoneNumberForDisplay } from '../../helpers/utils';

const HoverCard = ({ HoverCardTrigger, AvatarId, AvatarName, AvatarImage, AvatarDesignation, AvatarEmail, AvatarPhone, AvatarIsExternal, CanSendMessage = true }) => {

    const [message, setMessage] = useState("");
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [isSendSuccessful, setIsSendSuccessful] = useState(false);
    const dispatch = useDispatch();
    const user = JSON.parse(localStorage.getItem("user"));
    const currentUserId = user.id;

    const sendNotification = () => {
        if(message){
            setIsButtonLoading(true);
                apiService
                  .createNotificationRequest({title: message, priority: 1, recipients: [AvatarId]})
                  .then(() =>{
                    setMessage("");
                    setIsButtonLoading(false);
                    setIsSendSuccessful(true);
                    setTimeout(() => {   
                        setIsSendSuccessful(false);
                    }, 1000);
                  })
                  .catch((err) => {
                    setIsButtonLoading(false);
                    dispatch(
                      generalActions.showToast({
                        title: "Something went wrong. Please try again later.",
                        type: "error",
                      })
                    );
                  });
        }
    }
    return (
        <>
            <Tooltip
                positioning="below-start"
                content={{
                    children: <>
                        <div className="hover-card-tooltip-container">
                            <div className="hover-card-header-section">
                                <div className="hover-card-user-info">
                                        <div className="hover-card-avatar-wrapper">
                                            <Avatar 
                                                style={{ 
                                                    width: '50px', 
                                                    height: '50px',
                                                    fontSize: '20px',
                                                    fontWeight: '600'
                                                }} 
                                                name={AvatarName} 
                                                image={{ src: AvatarImage }}
                                                color="colorful" 
                                            />
                                        </div>
                                    <div className="hover-card-user-details">
                                        <h3 className="hover-card-user-name">
                                            {AvatarName}
                                        </h3>
                                        <p className="hover-card-user-title">
                                            {AvatarDesignation}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="hover-card-contact-section">
                                <div className="hover-card-contacts-group">
                                    {(AvatarEmail || AvatarPhone ) && (
                                        <h4 className="hover-card-contacts-title">Contact</h4>
                                    )}
                                    <div className="hover-card-contact-items">
                                        {AvatarEmail && (
                                        <div className="hover-card-contact-item">
                                            <Mail className="hover-card-contact-icon" size={16} />
                                            <span className="hover-card-contact-text"><a href={`mailto:${AvatarEmail}`}>{AvatarEmail}</a></span>
                                        </div>
                                        )}
                                        {AvatarPhone && (
                                            <div className="hover-card-contact-item">
                                                <Phone className="hover-card-contact-icon" size={16} />
                                                <span className="hover-card-contact-text"><a href={formatPhoneForTelHref(AvatarPhone)}>{formatPhoneNumberForDisplay(AvatarPhone)}</a></span>
                                            </div>
                                        )}
                                        <div className="hover-card-contact-item">
                                            <Building className="hover-card-contact-icon" size={16} />
                                            <span className="hover-card-contact-text">{AvatarIsExternal ? 'External' : 'Internal'} </span>
                                        </div>
                                    </div>
                                </div>
                                {CanSendMessage && AvatarId != currentUserId &&
                                (
                                    <div className="hover-card-actions">
                                                <Input
                                                    inputwd = "inputWidth"
                                                    value={message}
                                                    type="text"
                                                    handleChange={setMessage}
                                                    onKeyDown={(e) =>
                                                        e.key === "Enter" && sendNotification()
                                                      }
                                                    placeholder="Send a quick message"
                                                />
                                                <button className="hover-card-action-btn hover-card-message-btn" onClick={sendNotification}>
                                                    {isButtonLoading ? 
                                                        <Spinner
                                                            className="me-1"
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        /> :
                                                            isSendSuccessful ?
                                                            <Check color="#107c10" />
                                                            :
                                                      <Send className="hover-card-send-icon" size={16}/>
                                                    }  
                                                </button>                
                                    </div>
                                )
                                }
                                
                            </div>
                        </div>
                    </>, 
                    className: "hover-card-tooltip-wrapper"
                }}
                relationship="description"
            >
                <div>
                    {HoverCardTrigger}
                </div>
            </Tooltip>
        </>
    )
}

export default HoverCard;